import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNDrug } from 'src/app/models/cndrug';
import { CNDrugPackage } from 'src/app/models/cndrugpackage';
import { DrugService } from 'src/app/services/drug.service';

@Component({
  selector: 'app-drug-table',
  templateUrl: './drug-table.component.html',
  styleUrls: ['./drug-table.component.scss']
})
export class DrugTableComponent implements OnInit {

  @Input() drugs: CNDrug[];
  @Output() selected: EventEmitter<[CNDrug, CNDrugPackage]> = new EventEmitter();
  displayedColumns: string[] = ['entry'];

  constructor() { }

  ngOnInit(): void {
  }

  selectDrugPackage(drugpackage: [CNDrug, CNDrugPackage]) {
    this.selected.emit(drugpackage);
  }
}
